import { useTranslation } from "react-i18next";
import MScreen from "../../components/pos/MScreen";
import DoneIcon from "@mui/icons-material/Done";
import MText from "../../components/pos/MText";
import { Grid, CardContent, Card } from "@mui/material";
import { useState } from "react";

export default function MCustomFields(props, ref) {
  const { t, i18n } = useTranslation();
  const translate = t;

  const [title, setTitle] = useState("");

  return (
    <MScreen
      title={translate("Notes")}
      isMoreMenuEnabled={false}
      onRedirectToBack={() => props.setCurrentScreen("sale")}
      rightAction={translate("OK")}
      onRightAction={() => {
        props.setCurrentScreen("payment");
      }}
      rightActionIcon={<DoneIcon></DoneIcon>}
      enbaleRightAction={true}
      onLogOut={props.onLogOut}
      content={
        <Grid container>
          {props.customFields.map((item) => (
            <Grid item xs={12} sx={{ marginTop: "10px" }} key={item.label}>
              <MText
                label={item.label}
                value={item.value}
                onChange={(e) => {
                  let custom = [...props.customFields];
                  custom[item.index].value = e.target.value;
                  props.setCustomFields(custom);
                }}
              ></MText>
            </Grid>
          ))}
        </Grid>
      }
    ></MScreen>
  );
}
